// extracted by mini-css-extract-plugin
export default {"pagination":"AppPagination_pagination__LDS-1","itemsCount":"AppPagination_itemsCount__d1AoV"};